var map = {
	"./King Arthur's Return_1920x1080.webp": 13580,
	"./background-foe-building-buying-baking-video-poster.jpg": 66138,
	"./background-foe-trailer-craftsman.jpg": 59427,
	"./background-foe-wood-pattern.jpg": 78750,
	"./contentbox-foe-iframe-background.jpg": 28317,
	"./foe-stellar-age-bg.webp": 8241,
	"./foe_ingame_bg_rework.jpg": 25551,
	"./foe_ingame_bg_wider.png": 89198,
	"./foe_mobile_bg.jpg": 96105,
	"./form-foe-button.png": 26478,
	"./form0-foe-background.jpg": 72068,
	"./ingame-foe-real-ingame-build-up2.jpg": 16816,
	"./ingame-foe-sprite-deer-1.png": 15863,
	"./ingame-foe-sprite-gatherer.png": 76233,
	"./ingame-foe-sprite-hunter.png": 2031,
	"./ingame-foe-sprite-rabbits.png": 78114,
	"./ingame-foe-sprite-shaman.png": 1099,
	"./ingame-foe-townhall-construction-additional.png": 34064,
	"./ingame-foe-townhall-construction.png": 65824,
	"./ingame-foe-townhall-construction_2.png": 90611,
	"./ingame-foe-townhall-lvl1-additional.png": 21712,
	"./ingame-foe-townhall-lvl1.png": 95328,
	"./ingame-foe-townhall-lvl1_2.png": 26003,
	"./ingame-foe-townhall-lvl2-additional.png": 14217,
	"./ingame-foe-townhall-lvl2.png": 92891,
	"./ingame-foe-townhall-lvl2_2.png": 41180,
	"./ingame-foe-townhall-lvl3-additional.png": 42510,
	"./ingame-foe-townhall-lvl3.png": 71346,
	"./ingame-foe-townhall-lvl3_2.png": 73213,
	"./ingame-growing-city-test/building1_level1.png": 78940,
	"./ingame-growing-city-test/building1_level2.png": 37047,
	"./ingame-growing-city-test/building1_level3.png": 91470,
	"./ingame-growing-city-test/building2_level3.png": 38423,
	"./ingame-growing-city-test/building3_level2.png": 15469,
	"./ingame-growing-city-test/building3_level3.png": 52228,
	"./ingame-growing-city-test/building4_level1.png": 80447,
	"./ingame-growing-city-test/building4_level2.png": 95172,
	"./ingame-growing-city-test/building4_level3.png": 58413,
	"./ingame-growing-city-test/building5_level2.png": 42619,
	"./ingame-growing-city-test/building_tree.png": 21352,
	"./ingame-growing-city-test/con_2x2.png": 66334,
	"./ingame-growing-city-test/con_3x3.png": 67174,
	"./ingame-growing-city-test/con_3x4.png": 55801,
	"./ingame-growing-city-test/foe_ingame_bg_rework.jpg": 76540,
	"./ingame-growing-city-test/foe_ingame_bg_rework_extended.jpg": 48826,
	"./ingame-growing-city-test/industrial_main.png": 86908,
	"./ingame-growing-city-test/level1_building1.png": 29076,
	"./ingame-growing-city-test/level1_building4.png": 71417,
	"./ingame-growing-city-test/level1_building5.png": 65168,
	"./ingame-growing-city-test/level1_building7.png": 88482,
	"./ingame-growing-city-test/level1_building8.png": 9861,
	"./ingame-growing-city-test/level2_building1.png": 40919,
	"./ingame-growing-city-test/level2_building2.png": 16988,
	"./ingame-growing-city-test/level2_building4.png": 82474,
	"./ingame-growing-city-test/level2_building5.png": 14387,
	"./ingame-growing-city-test/level2_building7.png": 39905,
	"./ingame-growing-city-test/level2_building8.png": 12038,
	"./ingame-growing-city-test/level3_building1.png": 60022,
	"./ingame-growing-city-test/level3_building2.png": 91789,
	"./ingame-growing-city-test/level3_building3.png": 12196,
	"./ingame-growing-city-test/level3_building4.png": 67003,
	"./ingame-growing-city-test/level3_building5.png": 45458,
	"./ingame-growing-city-test/level3_building7.png": 85792,
	"./ingame-growing-city-test/level3_building8.png": 30023,
	"./speech-bubble-arrow.png": 46335,
	"./speech-bubble-frame.png": 19695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27139;